exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageTitle[data-v-3a07c004] {\n  margin-bottom: 2rem;\n}\n@media (max-width: 768px) {\n.pageTitle[data-v-3a07c004] {\n      font-size: 1.75rem;\n}\n}\n.pageContent[data-v-3a07c004] {\n  max-width: 764px;\n}\n.equipment-section[data-v-3a07c004] {\n  padding: 4rem;\n}\n@media (max-width: 768px) {\n.equipment-section[data-v-3a07c004] {\n      padding: 4rem 1rem;\n}\n}\n.productSectionTitle[data-v-3a07c004] {\n  margin-bottom: 4rem;\n}\n@media (max-width: 480px) {\n.productSectionTitle[data-v-3a07c004] {\n    text-align: center;\n    font-size: 1.5rem;\n    margin-bottom: 2rem;\n}\n}\n", ""]);

// exports
